export class Integration {
  constructor(
    readonly id: string,
    readonly enabled: boolean,
    readonly type: 'docplanner-visit-confirmation' | 'voicemail',
    readonly name: string,
  ) {}
}
